import { useState } from "react";
import {
    motion,
    AnimatePresence,
    useScroll,
    useMotionValueEvent,
} from "framer-motion";
import { trackTelegramClick, TELEGRAM_URL } from "@/config";

const StickyCTA = () => {
    const [visible, setVisible] = useState(false);
    const { scrollY } = useScroll();
    useMotionValueEvent(scrollY, "change", (v) => setVisible(v > 550));

    return (
        <AnimatePresence>
            {visible && (
                <motion.div
                    initial={{ y: 96, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    exit={{ y: 96, opacity: 0 }}
                    transition={{ type: "spring", stiffness: 300, damping: 30 }}
                    className="fixed inset-x-0 bottom-0 z-40 md:hidden"
                    data-testid="sticky-cta-bar"
                >
                    <div className="glass border-t border-white/10 px-4 pb-[max(0.9rem,env(safe-area-inset-bottom))] pt-3">
                        <a
                            href={TELEGRAM_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={() => trackTelegramClick("Sticky Button")}
                            data-testid="sticky-cta-button"
                            className="flex w-full items-center justify-center gap-2 rounded-full bg-gradient-to-b from-white to-[#c9ccd4] py-3.5 font-display text-sm font-extrabold uppercase tracking-wide text-ink shadow-[0_8px_30px_-6px_rgba(255,255,255,0.45)]"
                        >
                            🔥 Book Free Seat
                        </a>
                        <p className="mt-1.5 text-center font-mono text-[10px] uppercase tracking-[0.18em] text-white/45">
                            Free entry • Terhad 100 pax
                        </p>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default StickyCTA;
